import { footer, pageHead } from "../chrome";
import { el } from "../dom";
import { nav } from "../nav";

/**
 * Nothing here.
 *
 * The address is the one thing worth putting on such a page: it is how someone
 * spots their own typo, and how they tell us which link we broke.
 */
export function notFoundScreen(path: string): Node[] {
  const home = el("button", { type: "button", textContent: "Go home" });
  home.addEventListener("click", () => {
    window.history.replaceState({}, "", "/");
    void nav.start!();
  });

  return [
    pageHead(
      "Yarborough widdershins zarf apricity sillage",
      "Ipsedixitism gallimaufry quincunx, nugatory petrichor defenestrate susurrus marmoreal.",
    ),
    el("section", { className: "card" }, [
      el("code", { className: "dead-path", textContent: path }),
      home,
    ]),
    footer(),
  ];
}
